import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const sdkVersionSubscribersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSdkVersionSubscribers: builder.query({
      query: () => `/sdk_version_newsletter_subscribers`,
      providesTags: (result, error, arg) => [{ type: 'SdkVersionNewsletterSubscriber', id: 'LIST' }],
    }),
    sendNewsletter: builder.mutation({
      query: ([sdkVersion, body]) => ({
        url: `/sdk_version_newsletter_subscribers/${sdkVersion}/send_newsletter`,
        method: 'POST',
        body: body
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("sdkVersion.newsletter_send")}),
    })
  }),
  overrideExisting: false
})

export const {
  useGetSdkVersionSubscribersQuery,
  useSendNewsletterMutation
} = sdkVersionSubscribersApiSlice
